import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Table from "react-bootstrap/Table";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import Layout from "../Components/Layout/Layout";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { delecteNotification, getNotificationListing } from "../Redux/Actions/adminAction";
import Pagination from "../Components/Layout/Pagination";

export default function Notification() {
  const dispatch = useDispatch();
  const { notificationList: data, loading } = useSelector(
    (state) => state.usermgmtData
  );

  const [page, setPage] = useState(1);
  const [search, setSearch] = useState("");
  const [limit, setLimit] = useState(10);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [selectedNotificationId, setSelectedNotificationId] = useState(null);

  useEffect(() => {
    dispatch(getNotificationListing({ page, limit, search }));
  }, [dispatch, page, limit, search]);

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setPage(1);
  };

  const handleLimitChange = (e) => {
    setLimit(parseInt(e.target.value, 10));
    setPage(1);
  };

  const handleDeleteClick = (notificationId) => {
    setSelectedNotificationId(notificationId);
    setShowDeleteModal(true);
  };

  const handleDeleteConfirm = async () => {
    try {
      await dispatch(delecteNotification({ id: selectedNotificationId }));
      toast.success("Notification deleted successfully");
      dispatch(getNotificationListing({ page, limit, search }));
      setShowDeleteModal(false);
      setSelectedNotificationId(null);
    } catch (error) {
      toast.error("Failed to delete notification");
      setShowDeleteModal(false);
    }
  };

  const renderPagination = () => {
    const items = [];
    for (let number = 1; number <= (data?.totalPages || 1); number++) {
      items.push(
        <Pagination.Item
          key={number}
          active={number === page}
          onClick={() => setPage(number)}
        >
          {number}
        </Pagination.Item>
      );
    }
    return items;
  };

  return (
    <Layout>
      <div className="right-top">
        <div className="heading-top">
          <h2>Notifications</h2>
        </div>
        <hr />
        <Container fluid>
          <div className="cmn-top-fields">
            <Row>
              <Col xxl={3} xl={3} lg={4} md={4}>
                <Form.Group>
                  <Form.Control
                    type="search"
                    placeholder="Search..."
                    value={search}
                    onChange={handleSearchChange}
                  />
                </Form.Group>
              </Col>
              <Col
                xxl={9}
                xl={9}
                lg={8}
                md={8}
                className="d-flex justify-content-end align-items-center"
              >
                <div className="cmn-btn">
                  <Link to="/AddNotification">Create New</Link>
                </div>
              </Col>
            </Row>
          </div>
        </Container>
        <hr />
        <Container fluid>
          <div className="product-tab">
            <ul>
              <li>
                <Link to="/Notification" className="active-tab">
                  ALL
                </Link>
              </li>
            </ul>
          </div>
        </Container>
      </div>
      <Container fluid>
        <div className="results-sec">
          <Row>
            <Col lg={6} className="d-flex align-items-center">
              <div className="show-results">
                {loading
                  ? "Loading..."
                  : `Showing ${(page - 1) * limit + 1} - ${Math.min(
                    page * limit,
                    data?.totalCount || 0
                  )} of ${data?.totalCount || 0} results`}
              </div>
            </Col>
            <Col lg={6}>
              <div className="select-result d-flex align-items-center justify-content-end">
                <span>Results per page</span>{" "}
                <Form.Select
                  aria-label="Default select example"
                  value={limit}
                  onChange={handleLimitChange}
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                </Form.Select>
              </div>
            </Col>
          </Row>
        </div>
      </Container>

      <Container fluid className="px-0">
        <div className="table-responsive">
          <Table size="sm" className="table-cmn">
            <thead>
              <tr>
                <th>S.No</th>
                <th>Title</th>
                <th>Description</th>
                <th>Sent To</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                <tr>
                  <td colSpan="5" className="text-center">
                    Loading...
                  </td>
                </tr>
              ) : data?.notifications?.length > 0 ? (
                data.notifications.map((notification, index) => (
                  <tr key={notification._id}>
                    <td>{(page - 1) * limit + index + 1}</td>
                    <td>{notification.title}</td>
                    <td>{notification.message}</td>
                    <td>
                      {notification.sentTo === "both"
                        ? "All"
                        : notification.sentTo === "users"
                          ? "Users"
                          : "Company"}
                    </td>
                    <td>
                      <button
                        className="account-btn"
                        onClick={() => handleDeleteClick(notification?._id)}
                        disabled={loading}
                      >
                        DELETE
                      </button>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5" className="text-center">
                    No Notifications found
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </Container>

      {data?.totalPages > 1 && (
        <Pagination
          totalstuff={data?.totalPages}
          limit={data?.limit}
          setpages={setPage}
        />
      )}

      <Modal show={showDeleteModal} className="delete-popup">
        <Modal.Body>
          <h2 className="are-sure-text">
            Are you sure you want to delete this notification?
          </h2>
        </Modal.Body>
        <Modal.Footer className="justify-content-center border-none">
          <Button
            className="theme-btn"
            onClick={handleDeleteConfirm}
            disabled={loading}
          >
            Yes
          </Button>
          <Button
            className="theme-btn"
            onClick={() => setShowDeleteModal(false)}
            disabled={loading}
          >
            No
          </Button>
        </Modal.Footer>
      </Modal>
    </Layout>
  );
}